import { useEffect } from "react"

import { loadBadgedFavicon, setFaviconHref } from "./favicon-badge"
import { useUnreadNotifications } from "./use-notifications"

/** Red dot on the browser tab icon while any notification is unread. */
export function NotificationFaviconBadge() {
	const hasUnread = useUnreadNotifications().count > 0

	useEffect(() => {
		if (!hasUnread) return
		let active = true
		void loadBadgedFavicon().then((href) => {
			if (active && href) setFaviconHref(document, href)
		})
		return () => {
			active = false
			setFaviconHref(document, null)
		}
	}, [hasUnread])

	return null
}
